import {Modal, ModalProps, Switch} from "antd";
import StandardTable, {StandardColumnsType} from "../StandardTable";
import useAntTable from "../../utils/useAntTable";
import * as contractApi from "../../apis/platforms/admin/contract";
import {useEffect} from "react";
import {Method} from "axios";
import rebate from "../../pages/rebate";
import {SwitchChangeEventHandler} from "antd/lib/switch";




interface ContractSelectModalProps extends ModalProps{
    multiple?: boolean;
    columns?:StandardColumnsType
    onComplete:(keys:any[], records:any[])=>void
    url?:string
    queryParams?:any
    method?:Method
    rebate?:boolean;
    setRebate?:SwitchChangeEventHandler
}

function ContractSelectModal(props: ContractSelectModalProps) {
    const {multiple=false, url, queryParams={}, onCancel, onOk,onComplete, columns=[],rebate=false, setRebate, ...otherProps} = props;
    const {tableProps, form, search, refresh} = useAntTable(url, {method: props.method || 'get', selectTable: multiple || 'radio', defaultParams: {...queryParams}});


    useEffect(()=>{
        refresh();
    },[url]);

    const tableColumns = columns.length?columns:[
        {
            dataIndex: 'code',
            key: 'code',
            title: '合同编号'
        },
        {
            dataIndex: 'hospitalInstrumentsFullName',
            key: 'hospitalInstrumentsFullName',
            title: '终端医院'
        }
    ];

    const resetSelected = ()=>{
        tableProps.rowSelection.onChange([], []);
    }

    useEffect(()=>{
        if(otherProps.open){
            resetSelected();
        }
    },[otherProps.open]);

    const handleOk = (e:React.MouseEvent<HTMLButtonElement>) =>{
        onOk && onOk(e);
        onComplete && onComplete(tableProps.rowSelection.selectedRowKeys||[], tableProps.rowSelection.selectedRows);
    }

    return <Modal {...otherProps} width={800} onCancel={onCancel} onOk={handleOk} title={'合同选择'}>
        <StandardTable {...tableProps} submit={search.submit} columns={tableColumns} form={form} rowKey={'id'}/>
        {setRebate && <p style={{color: 'var(--danger-color)', fontWeight: 'bold'}}>是否使用返利？<Switch checked={rebate}
                                                                                            onChange={setRebate}
                                                                                            checkedChildren={'是'}
                                                                                            unCheckedChildren={'否'}/>
        </p>}
    </Modal>

}

export default ContractSelectModal;